import { useAppSelector } from "app/store/hook";
import { UserInfoModel } from "app/model/ua/user-info";
import ArcDigitalClock from "app/components/arc/ArcDigitalClock";
import WeatherInfo from "app/components/common/WeatherInfo";
import DbSplyCs from "app/pages/db/admin/DbSplyCs";
import DbEnrgStatus from "app/pages/db/admin/DbEnrgStatus";
import DbBzkndEnrg from "app/pages/db/admin/DbBzkndEnrg";
import DbRe100Goal from "app/pages/db/admin/DbRe100Goal";
import DbComplexMap from "app/pages/db/admin/DbComplexMap";
import DbRe100Join from "app/pages/db/admin/DbRe100Join";
import DbFuflStatus from "app/pages/db/admin/DbFuflStatus";
import DbBzkndGhgs from "app/pages/db/admin/DbBzkndGhgs";
import useMgLatestTime from "../../../hooks/use-mgLatestTime-view";

export default function DbAdminBase() {
  const userInfo: UserInfoModel = useAppSelector(state => state.userInfo.userInfo);
  const displayTime = useMgLatestTime('KM');

  return (
    <div className="container">
      <div className="dashboard-wrap admin-dash">
        <div className="main-tit">
          <span className="name"><strong>{userInfo?.userNm}</strong>님 안녕하세요.</span>
          <span className="ymd-i">
            <ArcDigitalClock />
            <WeatherInfo />
          </span>
        </div>


        <div className="admin-flex-wrap">
          <div className="area1">
            {/* 산단 일일 공급/소비 전력 */}
            <DbSplyCs displayTime={displayTime} />

            {/* 에너지 현황 */}
            <DbEnrgStatus />

            {/* 업종별 에너지 현황 - (재확인 필요) */}
            <DbBzkndEnrg />
          </div>

          <div className="area2">
            {/* RE100 달성 */}
            <DbRe100Goal />

            {/* 산단 RE100 현황 지도 */}
            <DbComplexMap />
          </div>

          <div className="area3">
            {/* 산단 RE100 참여 현황 */}
            <DbRe100Join displayTime={displayTime}/>

            {/* 산단 이행수단 현황 */}
            <DbFuflStatus />

            {/* 업종별 온실가스 배출량 */}
            <DbBzkndGhgs />
          </div>
        </div>

      </div>
    </div>
  );
}